var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVolleyball(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64.3,25.8c2.6,0,5.3-1,7.3-3c4-4,4-10.6,0-14.7c-4-4-10.6-4-14.7,0s-4,10.6,0,14.7C59,24.8,61.6,25.8,64.3,25.8z M58.9,10 c1.5-1.5,3.4-2.2,5.4-2.2c2,0,3.9,0.7,5.4,2.2c3,3,3,7.8,0,10.8c-3,3-7.8,3-10.8,0C55.9,17.9,55.9,13,58.9,10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.4,97.6L94,72.1l-7.3,7.3l23.9,23.9v28.8c0.1,2.8,2.3,5,5.1,5s5.1-2.2,5.1-5v-30.9C121,100,120.5,98.6,119.4,97.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,84.9l16.4-16.4L68.5,46.7L94,21.2c2-2,2-5.3,0-7.3s-5.3-2-7.3,0L34,66.7L23.1,55.8c-2-2-5.3-2-7.3,0s-2,5.3,0,7.3 l14.5,14.5c2,2,5.3,2,7.3,0l14.5-14.5L74,84.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 37.3,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6,79.5L76.3,89.8v21.8l-18.5,18.5c-2,2-2,5.3,0,7.3s5.3,2,7.3,0l20-20c1-1,1.5-2.3,1.5-3.6L86.6,79.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolleyball);
export default __webpack_public_path__ + "static/media/volleyball.264872d0ef0f3cd2856d94abb11967c8.svg";
export { ForwardRef as ReactComponent };